import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProvidersService } from '../../providers.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HealthCareUseCase } from '../../usecase/HealthCareUseCase';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import Dates from 'src/app/utilities/Dates';
import { Directive, ElementRef, HostListener} from '@angular/core';

@Component({
    selector: 'note',
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.scss']
})
export class NoteComponent implements OnInit {
    note: any;
    mainForm: FormGroup;
    // statuses: any[] =  [{value:'Pending'},{value:'Investigating'}, {value:'Accepted'},{value:'Denied'}];

    notificationType: any[] = [
        {name: 'Mail', value:1},
        {name: 'Email', value: 2},
        {name: 'Phone call', value: 3},
        {name: 'Fax', value: 6},
        {name: 'Whatsapp/Text Message', value: 5},        
        {name: 'In Person', value: 4}
    ];

    taskProgress: any[] = [
        {name: 'Pending', value:1},
        {name: 'In Progress', value: 2},
        {name: 'Completed', value: 3}
    ];

    noteTypes: any[] = [
        {name: 'Internal Information Management Department', value:1},
        {name: 'Outsourcing Providers', value: 2},
        {name: 'Branches', value: 3},
        {name: 'Docs', value: 4},
        {name: 'Services', value: 5}
    ];
   
    constructor(private fb: FormBuilder, private route: ActivatedRoute,
        private providersService: ProvidersService, private healthcareUseCase : HealthCareUseCase, 
        private config: DynamicDialogConfig) {

        this.mainForm = fb.group({
            id:[],
            username:[],
            noteCreatedOn:[],
            eventDate:[null, Validators.required],
            comments:[null, Validators.required],
            notifiedBy:[null, Validators.required],
            noteType:[],                                                
        });
    }

    get valid() : boolean {
        return this.mainForm.valid;
    }

    ngOnInit() {
        if(this.config.data) {
            this.mainForm.patchValue(this.config.data);
            this.note = this.config.data;
        }
    }

    store() {
        if(this.mainForm.invalid) {
            Object.values(this.mainForm.controls).forEach(control => {
                control.markAsTouched();
            });
        }
        if(this.mainForm.valid) {
            this.healthcareUseCase.appendNote(this.mainForm.value);
            this.clean();
        }
    }


    clean() {
        this.mainForm.reset();
    }

    cancel() {
        this.healthcareUseCase.closeNote();
        this.clean();
    }

    activate() {

    }

    inactivate() {

    }
    
}


@Directive({
    selector: '[appCharacterCounter]'
  })
  
  export class CharacterCounterDirective {

    @Input() maxLength: number;
  
    constructor(private el: ElementRef) { }
  
    @HostListener('input', ['$event.target'])
    onInput(textArea: HTMLTextAreaElement): void {
      if (textArea.value.length > this.maxLength) {
        textArea.value = textArea.value.substring(0, this.maxLength);
      }
    }
  }

